import { Construtor } from './construtor';
import { CriterioAvaliacaoRotinaCliente } from './criterio-avaliacao-rotina-cliente';

export class CriterioReincidenciaRotina implements Construtor<CriterioReincidenciaRotina> {

    public idCriterioReincidenciaRotina: number;
    public idReincidenciaRotina: number;
    public idCriterioAvaliacaoRotinaCliente: number;
    public criterioAvaliacaoRotinaCliente: CriterioAvaliacaoRotinaCliente;
    public selecionado: boolean;
    public alterado: boolean;

    constructor(object?: any) {
        this.criterioAvaliacaoRotinaCliente = new CriterioAvaliacaoRotinaCliente();
        if (object !== undefined) {
            if (object instanceof (CriterioReincidenciaRotina)) {
                this.copyObject(object);
            } else {
                this.parseFromJson(object);
            }

            if (!this.modeloCompleto()) {
                return null;
            }
        }
    }

    parseFromJson(criterio: any): void {
        this.idCriterioReincidenciaRotina = criterio.idCriterioReincidenciaRotina;
        this.idCriterioAvaliacaoRotinaCliente = criterio.idCriterioAvaliacaoRotinaCliente;
        this.idReincidenciaRotina = criterio.idReincidenciaRotina;
        this.criterioAvaliacaoRotinaCliente = criterio.criterioAvaliacaoRotinaCliente;
    }

    copyObject(criterio: CriterioReincidenciaRotina): void {
        this.idCriterioReincidenciaRotina = criterio.idCriterioReincidenciaRotina;
        this.idCriterioAvaliacaoRotinaCliente = criterio.idCriterioAvaliacaoRotinaCliente;
        this.idReincidenciaRotina = criterio.idReincidenciaRotina;
        this.criterioAvaliacaoRotinaCliente = criterio.criterioAvaliacaoRotinaCliente;
    }

    modeloCompleto(): boolean {
        return this.idCriterioAvaliacaoRotinaCliente !== undefined && this.idReincidenciaRotina !== undefined;
    }

    getNewInstance(object?: any): CriterioReincidenciaRotina {
        return new CriterioReincidenciaRotina(object);
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/criterio-reincidencia-rotina.ts